import { getFirstImageUrl } from '@lib/utils';
import { DEFAULT_SHARE_IMAGE } from '@/constants/links';
import type { BlogNewsListItemProp, BlogNewsProp } from '@/services';

/**
 * 블로그·뉴스 포스트 목록 대표 이미지 우선순위를 일원화한다.
 *
 * 우선순위: heroImage(ACF - url 추가 방식) → featuredImage(WP native, CMS 대표 이미지 - 파일 지정 방식) →
 * seoOpengraphImage(Yoast, legacy 포스트용) → 본문 첫 이미지.
 *
 * 목록 아이템(BlogNewsListItemProp)은 content·seoOpengraphImage 가 없어
 * 앞 두 단계(heroImage → featuredImage)까지만 적용된다.
 *
 * 어느 것도 없으면 undefined 를 반환한다(빈 문자열은 넘기지 않음).
 */
export const resolvePostListImage = (
  post: Pick<BlogNewsListItemProp, 'heroImage' | 'featuredImage'> &
    Partial<Pick<BlogNewsProp, 'content' | 'seoOpengraphImage'>>,
): string | undefined =>
  post.heroImage ||
  post.featuredImage ||
  post.seoOpengraphImage ||
  (post.content ? getFirstImageUrl(post.content) : '') ||
  undefined;

/**
 * JSON-LD·OG/Twitter 메타 대표 이미지를 확정한다.
 * 본문 첫 이미지를 쓰고, 없으면 사이트 기본 공유 이미지(DEFAULT_SHARE_IMAGE)로 fallback 한다.
 * 항상 사용 가능한 이미지를 반환하므로 호출부에서 별도 fallback 처리가 필요 없다.
 */
export const resolvePostJsonLdImage = (
  post: Partial<Pick<BlogNewsProp, 'content'>>,
): string =>
  (post.content ? getFirstImageUrl(post.content) : '') || DEFAULT_SHARE_IMAGE;
